import React from 'react';
import { motion } from 'framer-motion';
const fadeInUp = {
  initial: {
    opacity: 0,
    y: 60
  },
  animate: {
    opacity: 1,
    y: 0
  },
  transition: {
    duration: 0.6,
    ease: "easeOut"
  }
};
const staggerContainer = {
  initial: "initial",
  whileInView: "animate",
  viewport: {
    once: true
  },
  variants: {
    animate: {
      transition: {
        staggerChildren: 0.15
      }
    }
  }
};
const steps = [{
  step: "1",
  title: "Get your API Key",
  desc: "Sign up and get instant access to your API credentials."
}, {
  step: "2",
  title: "Make API requests",
  desc: "Use Postman, cURL, or any HTTP client to interact with our endpoints."
}, {
  step: "3",
  title: "Retrieve signed URLs",
  desc: "Get secure, time-limited URLs for your processed PDFs."
}];
const HowItWorksSection = () => {
  return <section id="how-it-works" className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div className="text-center mb-16" initial="initial" whileInView="animate" viewport={{
        once: true
      }} variants={fadeInUp}>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 font-heading text-primary-foreground">
            Developer <span className="gradient-text-brand">Flow</span>
          </h2>
          <p className="text-xl text-foreground max-w-3xl mx-auto">
            Get started in minutes with our simple API
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div {...staggerContainer}>
            {steps.map((step, index) => <motion.div key={index} className="flex items-start space-x-6 mb-10" variants={fadeInUp}>
                <div className="bg-primary w-12 h-12 rounded-full flex items-center justify-center text-primary-foreground font-bold text-xl flex-shrink-0 shadow-md">
                  {step.step}
                </div>
                <div>
                  <h3 className="text-2xl font-bold mb-2 text-card-foreground font-heading">{step.title}</h3>
                  <p className="text-foreground">{step.desc}</p>
                </div>
              </motion.div>)}
          </motion.div>

          <motion.div className="bg-card rounded-xl p-1 shadow-2xl floating-animation border border-border" initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }}>
            <div className="code-block">
              <div className="token comment mb-2 text-sm"># Merge PDFs with cURL</div>
              <pre className="text-sm whitespace-pre-wrap">
                <span className="token keyword">curl</span> <span className="token keyword">-X</span> POST \<br />
                {"  "}<span className="token string">"https://connect.webfiny.com/v1/merge"</span> \<br />
                {"  "}<span className="token keyword">-H</span> <span className="token string">"Authorization: Bearer YOUR_API_KEY"</span> \<br />
                {"  "}<span className="token keyword">-F</span> <span className="token string">"files[]=@document1.pdf"</span> \<br />
                {"  "}<span className="token keyword">-F</span> <span className="token string">"files[]=@document2.pdf"</span>
              </pre>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
};
export default HowItWorksSection;